export const muiCssBaseline = {
  styleOverrides: {
    body: {
      backgroundColor: '#fff',
    },
  },
};
